import { server } from "@/state/server";
import type { Foto } from "@/state/types";

export function fotoURL(f: Foto, tamanyo: string) {
  return `${server}/${tamanyo}/${f.y}/${f.m}/${f.d}/${f.g}/${f.i}.jpg`;
}

export function fotoFecha(f: Foto) {
  return `${f.y}-${f.m}-${f.d} ${f.h}`;
}
